import { useMemo } from "react";
import { copy } from "shared/assets";
import { ContactTeaser, FileTeaser, ImageTeaser, PlaceTeaser } from "shared/components";
import { IInfoBlockItem, IInfoBlockItemType } from "shared/types";
import { capitalizeFirstLetter, getInfoBlockItemReadableName } from "shared/utils";

export const useInfoBlockItemsProps = (
  {
    places,
    contacts,
    files,
    images,
  }: {
    places?: IInfoBlockItemType[];
    contacts?: IInfoBlockItemType[];
    files?: IInfoBlockItemType[];
    images?: IInfoBlockItemType[];
  },
  type?: "edit" | "view"
) => {
  const itemsProps = useMemo(() => {
    const getTitle = (type: IInfoBlockItem) =>
      capitalizeFirstLetter(
        copy.infoBlockItem.list.title.replace("%s", getInfoBlockItemReadableName(type))
      );

    return [
      {
        sortItems: true,
        items: places,
        Component: PlaceTeaser,
        type: IInfoBlockItem.place,
        title: getTitle(IInfoBlockItem.place),
        componentProps: {
          hideMap: type === "edit",
          hasMapModal: type === "view",
        },
      },
      {
        sortItems: true,
        items: contacts,
        Component: ContactTeaser,
        type: IInfoBlockItem.contact,
        title: getTitle(IInfoBlockItem.contact),
      },
      {
        sortItems: true,
        items: files,
        Component: FileTeaser,
        type: IInfoBlockItem.file,
        title: getTitle(IInfoBlockItem.file),
      },
      {
        items: images,
        Component: ImageTeaser,
        type: IInfoBlockItem.image,
        title: getTitle(IInfoBlockItem.image),
      },
    ];
  }, [places, contacts, files, images, type]);

  return itemsProps;
};
